import React, { FC } from 'react'
import ShortcutsSubMenu from './ShortcutsSubMenu'
import styles from './Homepage.module.scss'
import { useSelector } from 'react-redux'
import { getHeroItems } from '../selectors'
import HeroCarousel from 'components/SA/Carousel/HeroCarousel/HeroCarousel'
import AnniversarySection from './AnniversarySection'
import FilmStrip from 'components/SA/FilmStrip/FilmStrip'
import { IMAGE_URLS } from '../helpers'
const HeaderSection: FC = () => {
  const heroItems = useSelector(getHeroItems)
  const heroCarouselImages = heroItems.map(
    ({ jpgLarge, title, description, ctaText, ctaLink, ctaTheme }) => ({
      src: jpgLarge,
      alt: title,
      title,
      description,
      ctaLink,
      ctaText,
      ctaTheme,
    })
  )
  return (
    <div className={styles.headerSection}>
      <HeroCarousel items={heroCarouselImages} />
      <ShortcutsSubMenu />
      <h1 className={styles.title}>
        Celebrate <span>15 Years</span> of Discovering Art You Love
      </h1>
      <FilmStrip images={IMAGE_URLS} speed={1} />
      <AnniversarySection />
    </div>
  )
}

export default HeaderSection
